import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const FramedImage = ({ src, alt, className = "", parallax = 40, natural = false, ratio, ...rest }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const [revealed, setRevealed] = useState(false);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce || natural ? [0, 0] : [-parallax, parallax]);

  useEffect(() => {
    if (revealed) return;
    const el = ref.current;
    if (!el) return;
    const check = () => {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) setRevealed(true);
    };
    check();
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [revealed]);

  return (
    <motion.div
      ref={ref}
      initial={{ clipPath: "inset(100% 0 0 0)" }}
      animate={revealed ? { clipPath: "inset(0% 0 0 0)" } : {}}
      transition={{ duration: 1.3, ease: EASE }}
      className="bg-[#FAF7F0] p-3 md:p-4"
      {...rest}
    >
      <div className="border border-[#0A0A0A]/60 p-1.5">
        <div className={`photo-frame relative overflow-hidden ${className}`}>
          <motion.img
            src={src}
            alt={alt}
            style={natural && ratio ? { aspectRatio: ratio } : { y }}
            className={natural ? "w-full h-auto" : "h-[115%] w-full object-cover"}
            loading="lazy"
          />
        </div>
      </div>
    </motion.div>
  );
};
